import { render, staticRenderFns } from "./versionGrade.vue?vue&type=template&id=57161359&scoped=true&"
import script from "./versionGrade.vue?vue&type=script&lang=js&"
export * from "./versionGrade.vue?vue&type=script&lang=js&"
import style0 from "./versionGrade.vue?vue&type=style&index=0&id=57161359&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57161359",
  null
  
)

export default component.exports